export default "__VITE_ASSET__C31m_84s__"